import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsToggle2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSettingsToggle2"><Path fillRule="evenodd" clipRule="evenodd" d="M1 11.75C1 8.57436 3.57436 6 6.75 6H17.25C20.4256 6 23 8.57436 23 11.75V12.25C23 15.4256 20.4256 18 17.25 18H6.75C3.57436 18 1 15.4256 1 12.25V11.75ZM17 7.5C14.5147 7.5 12.5 9.51472 12.5 12C12.5 14.4853 14.5147 16.5 17 16.5C19.4853 16.5 21.5 14.4853 21.5 12C21.5 9.51472 19.4853 7.5 17 7.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsToggle2;
